/**
 * Mental-health crisis contacts shown on psychiatry pages and profiles.
 *
 * Single source for both the SPA (<CrisisNotice>) and the build-time
 * prerender (crisisNoticeHtml), so the static HTML and the hydrated page
 * always carry the same numbers. Re-verify against current ACT Health and
 * Lifeline sources whenever this file changes (SEO audit reports 24/47/75).
 */
export interface CrisisContact {
  label: string;
  number: string;
  /** E.164-style dial string for tel: links. */
  dial: string;
  note?: string;
}

export const CRISIS_CONTACTS: readonly CrisisContact[] = [
  { label: "Emergency", number: "000", dial: "000", note: "if someone is at immediate risk" },
  {
    label: "Access Mental Health (ACT)",
    number: "1800 629 354",
    dial: "1800629354",
    note: "24/7 mental health crisis line",
  },
  { label: "Lifeline", number: "13 11 14", dial: "131114", note: "24/7 crisis support" },
];

export const CRISIS_NOTICE_HEADING = "Need help now?";

export function isPsychiatrySpecialty(value: string | null | undefined): boolean {
  return typeof value === "string" && /psychiatr/i.test(value);
}

/** Static twin of components/CrisisNotice.tsx (same `ds-crisis` markup). */
export function crisisNoticeHtml(): string {
  const items = CRISIS_CONTACTS.map(
    (contact) =>
      `<li><span>${contact.label}</span><a class="ds-num" href="tel:${contact.dial}">${contact.number}</a>${contact.note ? `<span class="ds-fine">${contact.note}</span>` : ""}</li>`,
  ).join("");
  return `<aside class="ds-crisis" role="note" aria-label="Mental health crisis contacts"><h2 class="ds-title">${CRISIS_NOTICE_HEADING}</h2><ul class="ds-crisis__list">${items}</ul><p class="ds-fine">PulseBoard is a referral directory, not a crisis service.</p></aside>`;
}
